import { createContext, useContext } from 'react';

export const TaskRefreshContext = createContext(() => {});

export const useTaskRefresh = () => useContext(TaskRefreshContext);
